/**
 * @generated SignedSource<<f3fbc486a3d8a5697444a5b9142164d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ActivityVerb = "FINISHED" | "IN_PROGRESS" | "WISHLIST" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type MovieLandingPageRecentActivitiesQuery$data = {
  readonly recent_activities: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "Activity";
        readonly comment: string;
        readonly entity: {
          readonly cover_url: string;
          readonly id: string;
          readonly name: string;
          readonly original_name: string | null;
        };
        readonly id: string;
        readonly user: {
          readonly avatar: string | null;
          readonly display_name: string;
          readonly username: string;
        };
        readonly verb: ActivityVerb;
      };
    } | null> | null;
  };
  readonly " $fragmentType": "MovieLandingPageRecentActivitiesQuery";
};
export type MovieLandingPageRecentActivitiesQuery$key = {
  readonly " $data"?: MovieLandingPageRecentActivitiesQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"MovieLandingPageRecentActivitiesQuery">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MovieLandingPageRecentActivitiesQuery",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "kind",
          "value": "movie"
        }
      ],
      "concreteType": "ActivityConnection",
      "kind": "LinkedField",
      "name": "recent_activities",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ActivityEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Activity",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "verb",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "comment",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Movie",
                  "kind": "LinkedField",
                  "name": "entity",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "original_name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cover_url",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "user",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "display_name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "username",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "avatar",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "recent_activities(kind:\"movie\")"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "bef7ab9541902446f1753b5bafc346ff";

export default node;
